module.exports = __webpack_public_path__ + "static/media/alex.251e26f6.png";